import cx from 'clsx';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useController, useWatch } from 'react-hook-form';

import placeholderPng from '@assets/images/placeholder.png';
import { ReactComponent as LetterIcon } from '@assets/svg/ic-letter.svg';

import { FILE_SIZE_LIMIT } from '@constants/dropzoneFileLimits';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import { USER_FIELDS } from '../../constants/schemaUser';
import style from './style.module.scss';

const Avatar = ({ userId, userStatus, control, showChangePhotoBtn }) => {
  const { t } = useTranslation();

  const {
    field: { value: imageValue, onChange: imageChange },
  } = useController({ name: USER_FIELDS.IMAGE, control });

  const dropzone = useDropzone({
    onDrop: (files) => {
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        imageChange(reader.result);
      };
      reader.onerror = (error) => console.log(error);
    },
    validator: (file) =>
      file.size > FILE_SIZE_LIMIT ? showToast({ variant: 'error', message: 'The file is too large.' }) : null,
    accept: { 'image/*': [] },
    noClick: true,
    noKeyboard: true,
    multiple: false,
  });

  const [nameFirst, nameLast, userEmail] = useWatch({
    name: [USER_FIELDS.NAME_FIRST, USER_FIELDS.NAME_LAST, USER_FIELDS.EMAIL],
    control,
  });

  const handleRemove = () => {
    imageChange(null);
  };

  return (
    <div className={style.userInfoWrapper}>
      <img src={imageValue || placeholderPng} className={style.userInfoImage} alt="avatar" />
      <div className={style.userInfo}>
        <div className={style.userInfoName}>
          <div>{`${nameFirst} ${nameLast}`}</div>
          {!!userId && (
            <div className={style.userStatusBlock}>
              <span className={cx(style.userInfoStatus, style[`userInfoStatus${userStatus}`])}>
                {userStatus}
              </span>
            </div>
          )}
        </div>
        {showChangePhotoBtn && (
          <div>
            {!!imageValue && !imageValue.includes('placeholder') ? (
              <span className={style.btnPhotoChange} onClick={handleRemove}>
                {t('Remove photo')}
              </span>
            ) : (
              <span className={style.btnPhotoChange} onClick={dropzone.open}>
                {t('Add photo')}
              </span>
            )}

            <div {...dropzone.getRootProps()}>
              <input {...dropzone.getInputProps()} />
            </div>
          </div>
        )}
        {!showChangePhotoBtn && (
          <div className={style.userEmailInfo}>
            <LetterIcon className={style.emailIcon} />
            <span>{userEmail}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Avatar;
